
export const GET_USAGE_SUMMARY_REQUEST = "GET_USAGE_SUMMARY_REQUEST";
export const GET_USAGE_SUMMARY_SUCCESS = "GET_USAGE_SUMMARY_SUCCESS";
export const GET_USAGE_SUMMARY_FAILURE = "GET_USAGE_SUMMARY_FAILURE";

export const GET_USAGE_DAILY_REQUEST = "GET_USAGE_DAILY_REQUEST";
export const GET_USAGE_DAILY_SUCCESS = "GET_USAGE_DAILY_SUCCESS";
export const GET_USAGE_DAILY_FAILURE = "GET_USAGE_DAILY_FAILURE";

export const GET_USAGE_BY_MODEL_REQUEST = "GET_USAGE_BY_MODEL_REQUEST";
export const GET_USAGE_BY_MODEL_SUCCESS = "GET_USAGE_BY_MODEL_SUCCESS";
export const GET_USAGE_BY_MODEL_FAILURE = "GET_USAGE_BY_MODEL_FAILURE";

export const GET_USAGE_BY_CAPABILITY_REQUEST = "GET_USAGE_BY_CAPABILITY_REQUEST";
export const GET_USAGE_BY_CAPABILITY_SUCCESS = "GET_USAGE_BY_CAPABILITY_SUCCESS";
export const GET_USAGE_BY_CAPABILITY_FAILURE = "GET_USAGE_BY_CAPABILITY_FAILURE";

export const GET_USAGE_BUDGET_REQUEST = "GET_USAGE_BUDGET_REQUEST";
export const GET_USAGE_BUDGET_SUCCESS = "GET_USAGE_BUDGET_SUCCESS";
export const GET_USAGE_BUDGET_FAILURE = "GET_USAGE_BUDGET_FAILURE";

export const SET_USAGE_BUDGET_REQUEST = "SET_USAGE_BUDGET_REQUEST";
export const SET_USAGE_BUDGET_SUCCESS = "SET_USAGE_BUDGET_SUCCESS";
export const SET_USAGE_BUDGET_FAILURE = "SET_USAGE_BUDGET_FAILURE";

export const GET_USAGE_PERMISSION_REQUEST = "GET_USAGE_PERMISSION_REQUEST";
export const GET_USAGE_PERMISSION_SUCCESS = "GET_USAGE_PERMISSION_SUCCESS";
export const GET_USAGE_PERMISSION_FAILURE = "GET_USAGE_PERMISSION_FAILURE";

// --- summary ---
export const getUsageSummaryRequest = (range) => ({ type: GET_USAGE_SUMMARY_REQUEST, payload: { range } });
export const getUsageSummarySuccess = (summary) => ({ type: GET_USAGE_SUMMARY_SUCCESS, payload: { summary } });
export const getUsageSummaryFailure = (error) => ({ type: GET_USAGE_SUMMARY_FAILURE, payload: { error } });

// --- daily series ---
export const getUsageDailyRequest = (range) => ({ type: GET_USAGE_DAILY_REQUEST, payload: { range } });
export const getUsageDailySuccess = (daily) => ({ type: GET_USAGE_DAILY_SUCCESS, payload: { daily } });
export const getUsageDailyFailure = (error) => ({ type: GET_USAGE_DAILY_FAILURE, payload: { error } });

// --- by model ---
export const getUsageByModelRequest = (range) => ({ type: GET_USAGE_BY_MODEL_REQUEST, payload: { range } });
export const getUsageByModelSuccess = (byModel) => ({ type: GET_USAGE_BY_MODEL_SUCCESS, payload: { byModel } });
export const getUsageByModelFailure = (error) => ({ type: GET_USAGE_BY_MODEL_FAILURE, payload: { error } });

// --- by capability ---
export const getUsageByCapabilityRequest = (range) => ({ type: GET_USAGE_BY_CAPABILITY_REQUEST, payload: { range } });
export const getUsageByCapabilitySuccess = (byCapability) => ({ type: GET_USAGE_BY_CAPABILITY_SUCCESS, payload: { byCapability } });
export const getUsageByCapabilityFailure = (error) => ({ type: GET_USAGE_BY_CAPABILITY_FAILURE, payload: { error } });

// --- budget ---
export const getUsageBudgetRequest = () => ({ type: GET_USAGE_BUDGET_REQUEST });
export const getUsageBudgetSuccess = (budget) => ({ type: GET_USAGE_BUDGET_SUCCESS, payload: { budget } });
export const getUsageBudgetFailure = (error) => ({ type: GET_USAGE_BUDGET_FAILURE, payload: { error } });

export const setUsageBudgetRequest = (budget) => ({ type: SET_USAGE_BUDGET_REQUEST, payload: { budget } });
export const setUsageBudgetSuccess = (budget) => ({ type: SET_USAGE_BUDGET_SUCCESS, payload: { budget } });
export const setUsageBudgetFailure = (error) => ({ type: SET_USAGE_BUDGET_FAILURE, payload: { error } });

// --- permission (resource: aigateway) ---
export const getUsagePermissionRequest = () => ({ type: GET_USAGE_PERMISSION_REQUEST });
export const getUsagePermissionSuccess = (permission) => ({ type: GET_USAGE_PERMISSION_SUCCESS, payload: { permission } });
export const getUsagePermissionFailure = (error) => ({ type: GET_USAGE_PERMISSION_FAILURE, payload: { error } });
